import { render, staticRenderFns } from "./tv.vue?vue&type=template&id=5c66f468&scoped=true"
import script from "./tv.vue?vue&type=script&lang=js"
export * from "./tv.vue?vue&type=script&lang=js"
import style0 from "./tv.vue?vue&type=style&index=0&id=5c66f468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c66f468",
  null
  
)

export default component.exports